<div class="container-fluid">
<app-headercomponent></app-headercomponent>

@if (busy) {
  Getting everything ready. Please wait...
  <div class="progress-container">
    <mat-progress-bar mode="determinate" [value]="progressValue"></mat-progress-bar>
    <span class="progress-percentage">{{ progressValue }}%</span>
  </div>
}
@else{
  @if(errorMode){
    <div>{{message}}</div>
    <div>Please login again.</div>
    <div><a href="https://www.ceeyu.us">Login</a></div>
  }
}
<router-outlet></router-outlet>
</div>
 
